import { motion } from 'framer-motion';
import styled from 'styled-components';

import DoubleColumnSection, {
  DoubleColumnSectionProps,
} from 'components/DoubleColumnSection/DoubleColumnSection';
import { Categories } from 'components/DoubleColumnSection/DoubleColumnSection.styles';
import RichText from 'components/RichText/RichText';
import { setTypography } from 'utils/styles/mixins';
import { layout } from 'utils/styles/theme';

interface WrapperProps {}

const { max } = layout.columns;

export const Wrapper = styled.section<WrapperProps>`
  display: grid;
  grid-template-columns: repeat(${max}, 1fr);
  grid-column-gap: 32px;
`;

export const Motion = styled(motion.div)``;

export const Grid = styled.section`
  display: grid;
  grid-template-columns: repeat(${max}, 1fr);
`;

export const ContentWrapper = styled(Motion)`
  height: 100%;

  padding: 20px 0;
`;

export const RichTextWrapper = styled(RichText)`
  max-width: 840px;

  ${({ theme: { locale } }) => setTypography('heading1', locale)};
`;

export const IntroCopy = styled.div`
  max-width: 860px;

  margin: 32px 0 0 0;
`;

export const ExpertiseSection = styled(
  DoubleColumnSection
)<DoubleColumnSectionProps>``;

export const GetInTouchSection = styled(
  DoubleColumnSection
)<DoubleColumnSectionProps>`
  ${Categories} div img {
    margin: 16px 0 0;

    &:first-child {
      margin: 0 0 16px;
    }
  }

  ${Categories} div a {
    width: fit-content;
    display: block;
    margin: 16px 0 0;

    img {
      margin: 0 !important;
    }
  }

  p {
    margin: 0;
  }
`;

export const LeftSide = styled.aside`
  grid-column: 1 / 4;
`;

export const RightSide = styled.div`
  grid-column: 4 / 13;
`;
